import React, { useState } from 'react';
import { IonToggle } from '@ionic/react';

interface ToggleSwitchProps {
  /** Initial state of the toggle */
  defaultChecked?: boolean;
  /** Controlled value (if provided, component becomes controlled) */
  checked?: boolean;
  /** Callback fired when toggle state changes */
  onChange?: (checked: boolean) => void;
  /** Disable the toggle */
  disabled?: boolean;
  /** Additional CSS class name */
  className?: string;
}

function ToggleSwitch({
  defaultChecked = false,
  checked,
  onChange,
  disabled = false,
  className = '',
}: ToggleSwitchProps) {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  
  // Use controlled value if provided, otherwise use internal state
  const isChecked = checked !== undefined ? checked : internalChecked;

  const handleIonChange = (e: CustomEvent) => {
    const newValue = e.detail.checked;
    
    if (checked === undefined) {
      setInternalChecked(newValue);
    }
    
    onChange?.(newValue);
  };

  return (
    <IonToggle
      checked={isChecked}
      disabled={disabled}
      onIonChange={handleIonChange}
      className={className}
    />
  );
}

export default ToggleSwitch;

